import { ofType } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { searchPlayersSuccess, SearchTypes } from '../../actions/backoffice/search-actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { getLoginRequestHeader } from '../../../utils';
import { of } from 'rxjs';
import { IAction } from '../../../helpers/interfaces';
import { apiError } from '../../actions/user-actions';
import axios from 'axios';
import { SERVER_URL } from '../../../utils/config';

export const searchEpic = (action$: Observable<IAction>) =>
    action$.pipe(
        ofType(SearchTypes.SEARCH_PLAYERS_REQUEST),
        mergeMap((action) => {
            const headers = getLoginRequestHeader();
            const searchQuery = action.payload?.searchString || action.payload;
            const searchType = action.payload?.searchType || 'player';
            
            // Build URL with appropriate parameter based on search type
            let url = `${SERVER_URL}/player?`;
            if (searchType === 'player') {
                url += `name=${encodeURIComponent(searchQuery)}`;
            } else if (searchType === 'round') {
                url += `roundId=${encodeURIComponent(searchQuery)}`;
            } else if (searchType === 'transaction') {
                url += `transactionId=${encodeURIComponent(searchQuery)}`;
            }
            
            return from(
                axios.get(url, {
                    headers,
                }),
            ).pipe(
                map((response) =>
                    searchPlayersSuccess({
                        response: response.data,
                    }),
                ),
                catchError((error) => of(apiError(error, SearchTypes.SEARCH_PLAYERS_REQUEST))),
            );
        }),
    );
